module.exports = __webpack_public_path__ + "5e2ee9f1c9aba16cf7e7506408f6e58e.MP3";